export function replaceKeyPress(input, text) {

  if ('selectionStart' in input) {
      const start = input.selectionStart + 1;

      input.value = input.value.substr(0, input.selectionStart) + text + input.value.substr(input.selectionEnd, input.value.length);

      input.selectionStart = start;
      input.selectionEnd = start;
      input.focus();
  } else {
      input.value += text;
  }
};



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/directives/input-replace-keypress.ts